import { baseOnlyUniqueUrlValidator } from '../utils';
export var onlyUniqueSavedUrlValidator = function (value, validatorProps) {
    var pathPrefixes = validatorProps.pathPrefixes;
    var savedPathPrefixes = Object.values(pathPrefixes)
        .map(function (_a) {
        var savedPrefix = _a.savedPrefix;
        return savedPrefix;
    })
        .filter(Boolean);
    return baseOnlyUniqueUrlValidator(savedPathPrefixes)(value, validatorProps.defaultMapping.defaultSaved);
};
//# sourceMappingURL=only-unique-saved-url-validator.js.map